import React, { useState, useLayoutEffect } from 'react';
import connectionImg  from "../../images/svg/connection-interrupted.svg";

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
      function updateSize() {
          setSize([window.innerWidth, window.innerHeight]);
      }

      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}


const Spinner = () => (
  <div className="lds-spinner">
    {[...Array(12)].map((_, index) => (
      <div key={index}></div>
    ))}
  </div>
);

const ConnectionOverlay = ({ show }) => {

  const [width, height] = useWindowSize();


  if (!show) return null;

  return (
    <div className="iframe-pre-loader">
      <div className="iframe-pre-loader-bg" style={{'width': (100 * 1.777) + 'vh', 'maxWidth': '100vw'}}> </div>
     <div className='connection-overlay-loader'>
       <h3>Internet connection interrupted</h3>
      <img src={connectionImg} alt="connection-interrupted" />
      <Spinner />
      <p>Trying to reconnect...</p>
     </div>
     
     <div className='loader-background'></div>
     <div className='loader-background-animation'></div>
    </div>
  );
};

export default ConnectionOverlay;